import messages from '../../messages.json';

export const userStatus = {
  active: 'active', // アクティブユーザー
  invited: 'invited', // 招待中ユーザー
  expired: 'expired', // 招待メールの期限切れユーザー
} as const;

export const userStatusText: Record<UserStatus, string> = {
  [userStatus.active]: messages.user.userStatus.active,
  [userStatus.invited]: messages.user.userStatus.invited,
  [userStatus.expired]: messages.user.userStatus.expired,
};

type UserStatusList = typeof userStatus;
export type UserStatus = UserStatusList[keyof UserStatusList];
